





















import { Component, Vue,Inject, Prop, Watch } from 'vue-property-decorator';
import ECharts from 'vue-echarts'
import essos from './themes/essos.json'
import vintage from './themes/vintage.json'
import walden from './themes/walden.json'
import westeros from './themes/westeros.json'
import wonderland from './themes/wonderland.json'

@Component({
  components:{ECharts}
})
export default class extends Vue{
    @Prop({type:String,default:'图表'}) title:string;
    @Prop({type:String,default:'bar'}) type:string;
    //统计维度
    @Prop({type:Array,default:[]}) dimList:Array<any>;
    //统计目标
    @Prop({type:Array,default:[]}) data:Array<any>;
    //legend
    @Prop({type:Boolean,default:true}) legendShow:boolean;
    //loading
    @Prop({type:Boolean,default:false}) loading:Boolean;
    //dataZoom
    @Prop({type:Boolean,default:false}) dataZoom:Boolean;
    //搜索条件
    @Prop({type:Array,default:[]}) sOptions:any;
    vchange(){
        this.$emit('on-search',this.sOptions)
    }
    @Watch('loading')
    watchLoading(){
        this.renderCharts()   
        
    }
    // handleCurrentChange(val:any){
    //   this.$emit('handleCurrentChange',val)
    // }
    // handleSizeChange(val:any){
    //   this.$emit('handleSizeChange',val)
    // }
    created() {
        console.log(this.data)
        if(!this.loading){
            this.renderCharts()   

        }
        ECharts.registerTheme('ovilia-green', walden);  

    }
    echartsClick(event, instance, echarts){
        console.log(event)
        if(event.componentType!="series"){
            return false
        }
        let row;
        if(event.seriesType == 'line'){
            row = this.data.map((item:any)=>{return item.data[event.dataIndex]})
        }else{
            row = [event.data.name]
        }
        console.log(row)
        this.$emit('chartsClick',row)
    }
    option:any = {}
    renderCharts(){
        this.option = {
            tooltip : {
                show: true,
                backgroundColor: '#fff',
                borderColor: '#ddd',
                borderWidth: 1,
                textStyle: {
                    color: '#3c3c3c',
                },
            },
            grid: {
                left: '3%',
                right: new RegExp(/across/).test(this.type)?'10%':'4%',
                bottom: !new RegExp(/across/).test(this.type)?'10%':'4%',
                containLabel: true
            },
        };
        //横向竖向
        let axis1:any = [
            {
                type : 'value',
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#304156',//左边线的颜色
                        width:'2'//坐标线的宽度
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle:{
                        color: '#EBEEF5',
                        width: 1,
                        type: 'solid'
                    }
                },
                splitArea:{
                    show : true,
                    areaStyle:{
                        color:['#fff','#F9F9F9']
                    }
                },
                
            }
        ]
        let axis2:any = [
            {
                type : 'category',
                data : this.dimList,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#304156',//左边线的颜色
                        width:'2'//坐标线的宽度
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle:{
                        color: '#EBEEF5',
                        width: 1,
                        type: 'solid'
                    }
                }
            }
        ]
        if(this.dataZoom){
            this.option.dataZoom =  [{
                "show": true,
                "xAxisIndex": !new RegExp(/across/).test(this.type)?[0]:null,
                "yAxisIndex": new RegExp(/across/).test(this.type)?[0]:null,
                right: new RegExp(/across/).test(this.type)?20:'4%',
                handleSize: '110%',
                handleStyle: {
                    color: "#1E9FFF",
                },
                textStyle: {
                    color: "#1E9FFF"
                },
                borderColor: "#1E9FFF",
            }, {
                "type": "inside",
                "show": true,
                "height": 15,
                "start": 1,
                "end": 50,
                
                disabled:true,
                zoomLock:true
            }]
        }
        if(!new RegExp(/pie/).test(this.type) && !new RegExp(/funnel/).test(this.type)){
            if(new RegExp(/across/).test(this.type)){
                //保留网格区域
                axis1[0].splitArea = {
                    show : false,
                    areaStyle:{
                        color:['#F9F9F9','#fff']
                    }
                }
            }
            this.option.yAxis = new RegExp(/across/).test(this.type)?axis2:axis1
            this.option.xAxis = new RegExp(/across/).test(this.type)?axis1:axis2
            this.option.tooltip = {
                trigger: 'axis',
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                backgroundColor: '#fff',
                borderColor: '#ddd',
                borderWidth: 1,
                textStyle: {
                    color: '#3c3c3c',
                },
            }
        }else{
            this.option.tooltip = {
                trigger: 'item', 
                formatter: "{a} <br/>{b} : {c} ({d}%)",
                backgroundColor: '#fff',
                borderColor: '#ddd',
                borderWidth: 1,
                textStyle: {
                    color: '#3c3c3c',
                },
            }
        }
        //数据绑定
        this.option.series = this.data
        if(this.legendShow){
            let datalist = new RegExp(/pie/).test(this.type)||new RegExp(/funnel/).test(this.type)?this.data[0].data:this.data
            this.option.legend = {
                data:datalist.map((item:any)=>{
                    return item.name
                })
            }
        }
        console.log(this.data)
        console.log(this.sOptions,1111111111111111111111)

    }
}
